import styled from "styled-components";

export const PaymentContainer = styled.div`
  max-width: 100%;
  padding: 0;
  margin: 0;
`;
